export default "__VITE_ASSET__$NM$7lDF__"